// @flow
// Externals
import React, { useState, useMemo } from "react";
import Lottie from "react-lottie-player";

// Styles
// $FlowFixMe
import "./index.scss";

// Animation Data
import animationData from "../../static/lottie/Q16.json";
import { useEffect } from "react";

// Question Animation
/*::
type Props = {
	value: string,
	options: string[]
}
*/

const frames = [
	[0, 25],
	[0, 25],
	[35, 60],
	[70, 95],
	[105, 130],
	[140, 160],
	[0, 1],
	[0, 1],
];

const Animation = (props /*: Props */) /*: any */ => {
	//
	const [direction /*: number | null */, setDirection] = useState(null);
	const [previousFrame /*: number */, setPreviousFrame] = useState(0);
	const [segmentFrom /*: number | null */, setSegmentFrom] = useState(null);
	const [segmentTo /*: number | null */, setSegmentTo] = useState(null);

	const frame = useMemo(() => {
		return props.options.indexOf(props.value);
	}, [props.value, props.options]);

	useEffect(() => {
		if (frame === previousFrame) {
			// do nothing
		} else if (frame > previousFrame) {
			const segment = frames[frame];
			setDirection(1);
			setSegmentFrom(segment[0]);
			setSegmentTo(segment[1]);
		} else if (frame >= 0) {
			const segment = frames[frame];
			setDirection(-1);
			setSegmentFrom(segment[1]);
			setSegmentTo(segment[0]);
		}
		setPreviousFrame(frame);
	}, [frame, previousFrame]);

	return (
		<div className="animation animation-q16">
			{frame >= 0 && segmentFrom !== null && segmentTo !== null ? (
				<Lottie
					className="lottie-container basic"
					animationData={animationData}
					play={true}
					loop={false}
					segments={[segmentFrom, segmentTo]}
					direction={direction}
				/>
			) : (
				<Lottie
					className="lottie-container basic"
					animationData={animationData}
					play={false}
					loop={false}
				/>
			)}
		</div>
	);
};

// Exports
export default Animation;
